/** Browser navigation, isolated so tests can observe downloads. */
export const browser = {
  open(url: string) {
    window.location.assign(url);
  },
};
